import 'babel-polyfill';
import 'url-search-params-polyfill';

// Images
import 'lazysizes/plugins/respimg/ls.respimg';
// import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';

import './components/hero-carousel';
import './components/member-carousel';
import './components/news-carousel';
import './components/toggle';
import './components/navigation';
import './components/banner-alert';
import './components/secondary-dropdown-menu';
import './components/sponsoring-members-carousel';
import './components/featured-article-carousel';
import './components/smoothscroll';
import './components/date-range';
import './components/icon-slider';
import './components/news-filters';
import './components/forms';
import './components/forms/date-picker';
import './components/tables';
import './components/header-search';
import './components/stats-by-state';
import './components/member-type-selector';
import './components/member-options-carousel';
import './components/card-accordion-toggle';
import './components/sub-nav-carousel';
import './components/sub-nav-toggle';
import './components/maps';
import './components/newsletter-ajax';
import './components/enquiry-form';
import './components/popups';
import './components/grid-check';
import './components/education';
import Tabs from './components/tabs';

import './charts/extends';
import './charts/line-bar-chart';
import './charts/pie-chart';
import './charts/area-chart';
import './charts/pie-stats';

import './vue/product-search';
import './vue/current-members';
import './vue/events-grid';
import './vue/education-grid';
import './vue/news-grid';
import './vue/products';
import './vue/speakers';
// import './vue/installer-search/installer-search';
// import './vue/retailer-search/retailer-search';

import './vue/algolia-geosearch/main';
import './vue/courses/main';
import './vue/careers/main';

// import './components/pie-charts';

const alert = document.querySelector('.alert');
if (alert) {
    alert.addEventListener('click', () => {
        alert.classList.add('alert--remove');
    });
}

Tabs('.subscribe');